import { useLayoutEffect as e, useEffect as f } from "react";
var t = typeof window != "undefined" ? e : f;
export { t as useIsoMorphicEffect };